/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./moreCard.vue?vue&type=template&id=3f4f5814&scoped=true&"
import script from "./moreCard.vue?vue&type=script&lang=js&"
export * from "./moreCard.vue?vue&type=script&lang=js&"
import style0 from "./moreCard.vue?vue&type=style&index=0&id=3f4f5814&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_webpack@5.89.0__lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f5814",
  null
  
)

export default component.exports